import { FeedItemDto, FeedType } from "generated/CoreApi_v1";
import { useMentionInterceptor } from "hooks/useMentionInterceptor";
import { CardManager } from "views/knowledge/components/card/CardManager";

interface IProps {
    feedType: FeedType;
    publication: FeedItemDto;
    onReload: () => void;
    onFeedItemChanged: (data: Partial<FeedItemDto>) => void;
    onNeedResetRowHeight: () => void;
}

export const PublicationCardHeader: React.FC<IProps> = (props) => {
    const { feedType, publication, onReload, onFeedItemChanged, onNeedResetRowHeight } = props;
    const [mentionDialog] = useMentionInterceptor("publicationCardHeaderContainer");

    return (
        <div id="publicationCardHeaderContainer">
            {mentionDialog}
            <CardManager
                feedType={feedType}
                pub={publication!}
                onNeedResetRowHeight={onNeedResetRowHeight}
                onReload={onReload}
                onFeedItemChanged={onFeedItemChanged}
            />
        </div>
    );
};
